import {SpørreundersøkelseEnkelModell, SpørsmålModell, Spørsmålstype} from "../tjenester/ressurser/generertNg2HttpKlient";
import {erIkkeNil, erNil} from "../støttefunksjoner/nilsjekk";
import {nil} from "../typer/nullish";
import {sammenliknZonedDateTimePeriode, ZonedDateTimePeriodeLukket, ZonedDateTimePeriodeLukketSerialisert} from "felles-ng2/typer/ZonedDateTimePeriode";

export function spørsmålHarSammeTypeOgOppsett(a: SpørsmålModell | nil, b: SpørsmålModell | nil): boolean {
    if (erNil(a) || erNil(b)) return false;
    if (a.type != b.type) return false;
    return JSON.stringify(a.oppsett) == JSON.stringify(b.oppsett)
}

export function erSpørsmålSomKanBesvares(spørsmål: SpørsmålModell): boolean {
    return spørsmål.type != Spørsmålstype.grupperingstittel;
}

export function pågåendeUndersøkelser<E extends SpørreundersøkelseEnkelModell>(undersøkelser: E[]): E[] {
    return undersøkelser.filter(undersøkelse => undersøkelse.erAapenForRespons);
}

export function ikkePågåendeUndersøkelser<E extends SpørreundersøkelseEnkelModell>(undersøkelser: E[]): E[] {
    return undersøkelser.filter(undersøkelse => !undersøkelse.erAapenForRespons);
}

export function avsluttedeUndersøkelser<E extends SpørreundersøkelseEnkelModell>(undersøkelser: E[]): E[] {
    return undersøkelser.filter(undersøkelse => undersøkelse.erAvsluttet);
}

export function lesSpørreundersøkelseResponsperiode(undersøkelse: SpørreundersøkelseEnkelModell): ZonedDateTimePeriodeLukket | null {
    return ZonedDateTimePeriodeLukket.lesOpt(undersøkelse.responsperiode as ZonedDateTimePeriodeLukketSerialisert);
}

/** Sorterer spørreundersøkelser etter responsperiode slik at pågående undersøkelser kommer før avsluttede, så tittel.
 * Må være i synk med javasiden, se no.systemfabrikken.lederplan.domene.spørreundersøkelse.SpørreundersøkelseSøk.finnUndersøkelserKnyttetTilGruppe
 * @return En negativ verdi indikerer at a skal komme før b. En positiv verdi indikerer at a skal komme etter b. 0 indikerer at a og b anses som like. */
export function sorterSpørreundersøkelser(a: SpørreundersøkelseEnkelModell, b: SpørreundersøkelseEnkelModell): number {
    if (a === b) return 0;

    //siden sammenliknZonedDateTimePeriode blir kalt med b,a og ikke a,b må vi selv sørge for at undersøkelse.periode=null sorterer før undersøkelse.periode!=null
    if (erNil(a.responsperiode) && erIkkeNil(b.responsperiode)) return -1;
    if (erIkkeNil(a.responsperiode) && erNil(b.responsperiode)) return 1;

    let sortering = sammenliknZonedDateTimePeriode(lesSpørreundersøkelseResponsperiode(b), lesSpørreundersøkelseResponsperiode(a));
    if (sortering != 0) return sortering;

    sortering = a.tittel.localeCompare(b.tittel)
    if (sortering != 0) return sortering;

    return a.id.localeCompare(b.id);
}
